import { ReactNode } from 'react';
import { useAuth } from '@/contexts/auth';
import { canAccessRoute } from '@/utils/permissions';
import LoadingFull from '@/components/LoadingFull';
import { AccessDenied } from '@/components/AccessDenied';

interface PermissionRouteProps {
  children: ReactNode;
  route: string;
}

export const PermissionRoute = ({ children, route }: PermissionRouteProps) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingFull />;
  }

  if (!canAccessRoute(user, route)) {
    return <AccessDenied />;
  }

  return <>{children}</>;
};
